import { useState } from 'react';
import '../../App.css';
import './Footer.css';
import telefone from '../../assets/img/telefone.png';
import whatsapp from '../../assets/img/whatsapp.png';
import instagram from '../../assets/img/instagram.png';

export default function Footer(){

  return (
    <div className="Footer-container">

        <footer>
                <h3>Contato:</h3> <br/>
                <div className="alinha-contato">
                    <a href="tel:+5516992174903">
                        <img src={telefone} alt="telefone" />
                    </a>

                    <a href="https://wa.me/+5516992174903/" rel="noopener noreferrer" target="blank">
                         <img src={whatsapp} alt="whatsapp" />
                    </a> 

                    <a href="https://www.instagram.com/espacorafaelaoliveira/" rel="noopener noreferrer" target="blank">
                        <img src={instagram} alt="instagram" />
                    </a> 
                </div>
        </footer>
        

    </div>
  );  
}